import React, { useState, useEffect } from "react";
import "../../assets/styles/local/WorkflowAutomation.css";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchTriggers,
  FetchRules,
  FetchQuestions,
  FetchTaskStatus,
} from "../../redux/actions/workflowAutomationActions";
import eye from "../../assets/icons/eye.svg";
import FormDetailsModal from "./FormDetailsModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ConditionWorkflow = ({ applyCondition, formId }) => {
  const trigger_form_status = "01a4d346-e54b-497a-9cd8-feb571bb1001";
  const trigger_form_question = "01a4d346-e54b-497a-9cd8-feb571bb1002";

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(FetchTriggers());
    dispatch(FetchRules());
  }, []);

  const triggersList = useSelector((state) => state.user.workflowTriggerList);
  const rulesList = useSelector((state) => state.user.workflowRulesList);
  const questionList = useSelector((state) => state.user.workflowQuestions);

  const [triggerOption, setTriggerOption] = useState([
    {
      //   label: "Select Item",
      label: t("Select Item "),
      value: "",
      disabel: true,
    },
  ]);

  const [ruleOptions, setRuleOptions] = useState([
    {
      label: "- ",
      value: "",
      disabel: true,
    },
  ]);

  const [valueOption, setValueOption] = useState([
    {
      //   label: "Add Value",
      label: t("Add value"),
      value: "",
      disabel: true,
    },
    // {
    //     label: "-",
    //     value: "-",
    //     disabel: false,
    // },
    // {
    //     label: "Assigned",
    //     value: "Assigned",
    //     disabel: false,
    // },
    {
      label: "Completed",
      value: "Completed",
      disabel: false,
    },
  ]);

  const [questionOptions, setQuestionOptions] = useState([
    {
      label: "- ",
      value: "",
      disabel: true,
    },
  ]);

  useEffect(() => {
    if (triggersList && triggersList.status && triggersList.data.length > 0) {
      let triggerData = triggersList.data.map((o) => {
        return {
          label: o.triggerName,
          value: o.triggerId,
          disabel: false,
        };
      });
      setTriggerOption([
        {
          //   label: "Select Item",
          label: t("Select Item "),
          value: "",
          disabel: true,
        },
        ...triggerData,
      ]);
    }
  }, [triggersList]);

  useEffect(() => {
    if (rulesList && rulesList.status && rulesList.data.length > 0) {
      let ruleOptions = rulesList.data.map((o) => {
        return {
          label: o.ruleName + ` ${o.ruleValue}`,
          value: o.ruleId,
          disabel: false,
        };
      });

      setRuleOptions([...ruleOptions, ...ruleOptions]);
    }
  }, [rulesList]);

  useEffect(() => {
    if (questionList && questionList.status && questionList.data.length > 0) {
      let questionsList = questionList.data.flatMap((o) => o.children);

      let questions = questionsList.map((o) => {
        return {
          label: o.title,
          value: o.sectionFieldid,
          disabel: false,
        };
      });

      setQuestionOptions([
        {
          //   label: "Select Item",
          label: t("Select Item "),
          value: "",
          disabel: true,
        },
        ...questions,
      ]);
    }
  }, [questionList]);

  const [triggerId, setTriggerId] = useState("");
  const [ruleId, setRuleId] = useState("");
  const [valueName, setValueName] = useState("");
  const [question, setQuestionId] = useState("");
  const [showFormDetailsPopup, setShowFormDetailPopup] = useState(false);

  const onApplyClick = () => {
    const _trigger = triggerOption.find((o) => o.value === triggerId);
    const _rule = ruleOptions.find((o) => o.value === ruleId);

    applyCondition({
      triggerId: triggerId,
      ruleId: ruleId,
      value: valueName,
      triggerValue: _trigger.label,
      rule: _rule.label,
      questionId: question,
    });
  };

  const mapRules = (rule) => {
    if (rule === trigger_form_question) {
      console.log("Trigger From Question");

      if (rulesList && rulesList.status && rulesList.data.length > 0) {
        let _ruleOptions = rulesList.data.map((o) => {
          return {
            label: o.ruleName + ` ${o.ruleValue}`,
            value: o.ruleId,
            disabel: false,
          };
        });

        setRuleOptions([
          {
            label: "- ",
            value: "",
            disabel: true,
          },
          ..._ruleOptions,
        ]);
      }
    }

    if (rule === trigger_form_status) {
      console.log("Trigger From Status");
      if (rulesList && rulesList.status && rulesList.data.length > 0) {
        let _ruleOptions = rulesList.data.filter(
          (o) => o.ruleName === "Equal to"
        );

        if (_ruleOptions.length > 0) {
          let ruleOpt = _ruleOptions.map((o) => {
            return {
              label: o.ruleName + ` ${o.ruleValue}`,
              value: o.ruleId,
              disabel: false,
            };
          });

          setRuleOptions([
            {
              label: "- ",
              value: "",
              disabel: true,
            },
            ...ruleOpt,
          ]);
        }
      }
    }
  };

  const handleClose = () => {
    setShowFormDetailPopup(false);
  };

  const showFormModal = () => {
    setShowFormDetailPopup(true);
  };

  return (
    <>
      {/* input form section */}
      <div className="width-30-vw min-height-25vh">
        {/* Trigger Selection  */}
        <div className="workflow_input_wrap mt-4" style={{ marginBottom: 0 }}>
          <label className="workflow_form_label">
            {/* Trigger */}
            {t("Trigger ")}
          </label>
          <div className="input_wrap">
            <select
              placeholder="select"
              className="cursor-pointer"
              value={triggerId}
              onChange={(e) => {
                setTriggerId(e.target.value);
                mapRules(e.target.value);
              }}
            >
              {triggerOption.length &&
                triggerOption.map((o, i) => (
                  <option
                    key={i}
                    value={o.value}
                    disabled={o.disabel}
                    selected={o.disabel}
                    hidden={o.disabel}
                  >
                    {o.label}
                  </option>
                ))}
            </select>
          </div>
        </div>

        {triggerId !== "" && triggerId === trigger_form_question && (
          <>
            <div
              className="workflow_input_wrap mt-4"
              style={{ marginBottom: 0 }}
            >
              <label className="workflow_form_label">
                {/* Question */}
                {t("Question")}
              </label>
              <div className="workflow_form_img">
                <img
                  style={{ filter: "opacity(0.5)", cursor: "pointer" }}
                  src={eye}
                  onClick={showFormModal}
                />
              </div>
              <div className="input_wrap">
                <select
                  placeholder="select"
                  className="cursor-pointer"
                  value={question}
                  onChange={(e) => {
                    setQuestionId(e.target.value);
                  }}
                >
                  {questionOptions.length &&
                    questionOptions.map((o) => (
                      <option
                        value={o.value}
                        disabled={o.disabel}
                        selected={o.disabel}
                        hidden={o.disabel}
                      >
                        {o.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </>
        )}

        {/* Rule & Value Selection  */}
        {triggerId !== "" && (
          <>
            <Row>
              {/* Rule  */}
              <Col>
                <div
                  className="workflow_input_wrap mt-4"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">
                    {/* Rule */}
                    {t("Rule ")}
                  </label>
                  <div className="input_wrap">
                    <select
                      placeholder="select"
                      className="cursor-pointer"
                      value={ruleId}
                      onChange={(e) => {
                        setRuleId(e.target.value);
                      }}
                    >
                      {ruleOptions.length &&
                        ruleOptions.map((o) => (
                          <option
                            value={o.value}
                            disabled={o.disabel}
                            selected={o.disabel}
                            hidden={o.disabel}
                          >
                            {o.label}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </Col>

              {/* Value */}
              <Col>
                <div
                  className="workflow_input_wrap mt-4"
                  style={{ marginBottom: 0 }}
                >
                  <label className="workflow_form_label">
                    {/* Value */}
                    {t("Value")}
                  </label>
                  <div className="input_wrap">
                    {triggerId !== trigger_form_question && (
                      <select
                        placeholder="select"
                        className="cursor-pointer"
                        value={valueName}
                        onChange={(e) => {
                          setValueName(e.target.value);
                        }}
                      >
                        {valueOption.length &&
                          valueOption.map((o) => (
                            <option
                              value={o.value}
                              disabled={o.disabel}
                              selected={o.disabel}
                              hidden={o.disabel}
                            >
                              {o.label}
                            </option>
                          ))}
                      </select>
                    )}

                    {triggerId === trigger_form_question && (
                      <input
                        // placeholder="Value"
                        placeholder={t("Value")}
                        type="text"
                        value={valueName}
                        onChange={(e) => setValueName(e.target.value)}
                        style={{ fontSize: "14px" }}
                      />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}

        <FormDetailsModal
          animation={true}
          show={showFormDetailsPopup}
          close={handleClose}
          formId={formId}
        />
      </div>

      {/* Actions section   */}
      <div className="width-30-vw d-flex justify-content-center mt-4">
        <div className="apply-btn" onClick={onApplyClick}>
          {/* Apply */}
          {t("Apply ")}
        </div>
      </div>
    </>
  );
};

export default ConditionWorkflow;
